<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="white"
    />
    <path
      d="M21.3333 13.3334H16C15.6463 13.3334 15.3072 13.4738 15.0572 13.7239C14.8071 13.9739 14.6666 14.3131 14.6666 14.6667V25.3334C14.6666 25.687 14.8071 26.0261 15.0572 26.2762C15.3072 26.5262 15.6463 26.6667 16 26.6667H24C24.3536 26.6667 24.6927 26.5262 24.9428 26.2762C25.1928 26.0261 25.3333 25.687 25.3333 25.3334V17.3334L21.3333 13.3334Z"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.3334 13.3334V17.3334H25.3334"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.6667 20.6666H17.3334"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.6667 23.3334H17.3334"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6667 18H18H17.3334"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
